export const HireAngularBannerDataAr = {
    mainHeading: "وظف مطوري Angular",
    content: "شريكك الموثوق به لتطوير Angular الخبير، وهو مثالي للشركات الناشئة والمؤسسات التي تبحث عن تطبيقات ويب قابلة للتطوير وعالية الأداء.",
    btnText: "استشر مطوري Angular لدينا اليوم",
    HireAngularBannerList: [
        { list: "مقاولون مستقلون" },
        { list: "أدوار بدوام كامل" },
        { list: "مجموعة مواهب عالمية" },
    ]
};

export const HireAngularServicesDataAr = {
    mainHeading: "خبرتنا في تطوير Angular",
    sectionDescription: "يتفوق مطورو Angular لدينا في بناء تطبيقات ويب سريعة وتفاعلية وقابلة للتطوير، مما يضمن وظائف سلسة وتجارب مستخدم متميزة.",
    buttonText: "حدد موعدًا لإجراء مكالمة اليوم",
    servicesData: [
        {
            title: "استشارات Angular",
            description:
                "احصل على إرشادات الخبراء لتحسين مشاريع Angular الخاصة بك - سواء كنت تطلق تطبيقًا جديدًا أو تقوم بتحسين تطبيق موجود.",
            icon: "/images/hire-page-icons/hire-angular-icons1.svg",
        },
        {
            title: "تطوير ويب Angular",
            description:
                "نقوم بإنشاء تطبيقات ويب ديناميكية وسهلة الاستخدام ومتجاوبة توفر تجارب سلسة عبر جميع الأجهزة.",
            icon: "/images/hire-page-icons/hire-angular-icons2.svg",
        },
        {
            title: "تطوير Angular API",
            description:
                "يقوم فريقنا ببناء واجهات برمجة تطبيقات قوية (APIs) تتيح التواصل السلس بين المنصات، مما يضمن تبادل البيانات بكفاءة.",
            icon: "/images/hire-page-icons/hire-angular-icons3.svg",
        },
        {
            title: "تطوير Angular CMS وبوابات",
            description:
                "طور أنظمة إدارة محتوى (CMS) وبوابات ويب مخصصة قابلة للتطوير وعالية الأداء مع إدارة محتوى سهلة وواجهات بديهية.",
            icon: "/images/hire-page-icons/hire-angular-icons4.svg",
        },
        {
            title: "الترحيل إلى Angular",
            description:
                "انتقل بسلاسة إلى Angular مع الحفاظ على بياناتك وتحسين أداء التطبيق.",
            icon: "/images/hire-page-icons/hire-angular-icons5.svg",
        },
        {
            title: "التكامل مع الحلول الحالية",
            description:
                "ضمان التوافق التام بين تطبيقات Angular وأدواتك وخدماتك ومنصاتك الحالية.",
            icon: "/images/hire-page-icons/hire-angular-icons6.svg",
        },
        {
            title: "حلول التجارة الإلكترونية بـ Angular",
            description:
                "أنشئ منصات تجارة إلكترونية جذابة وغنية بالميزات توفر أداءً سريعًا وتجارب مستخدم سلسة.",
            icon: "/images/hire-page-icons/hire-angular-icons7.svg",
        },
        {
            title: "دعم وصيانة Angular",
            description:
                "حافظ على تطبيقات Angular الخاصة بك محسّنة وآمنة ومحدثة من خلال خدمات الدعم والصيانة الاستباقية لدينا.",
            icon: "/images/hire-page-icons/hire-angular-icons8.svg",
        },
    ],
};

export const HireAngularSolutionsDataAr = {
    mainHeading: "لماذا تختار بيتسكلان لتوظيف",
    greenHeading: "مُطوري Angular؟",
    sectionDescription: "نحن نستفيد من Angular والتقنيات الحديثة لتطوير تطبيقات قابلة للتطوير وعالية الأداء مصممة خصيصًا لتلبية احتياجات عملك. سواء كنت تقوم ببناء منصة ويب أو حل للهاتف المحمول، فإننا نضمن أداءً سلسًا وكفاءة وتجربة مستخدم لا مثيل لها.",
    buttonText: "توظيف مطور اليوم",
    solutions: [
        {
            icon: "/images/hire-page-icons/chose-ror-section1.svg",
            title: "الوصول إلى المواهب المعتمدة",
            description:
                "اعمل مع مطوري Angular المهرة، الذين تم فحصهم بعناية لخبرتهم الفنية ومهارات التواصل الفعالة.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section2.svg",
            title: "ابحث عن المطابق الصحيح فورًا",
            description:
                "تجاوز مراجعات السيرة الذاتية التي لا نهاية لها. باستخدام HireAI، اكتشف بسرعة أفضل مطوري Angular الذين يتناسبون مع متطلبات مشروعك.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section3.svg",
            title: "توظيف عالمي فعال من حيث التكلفة",
            description:
                "استفد من شبكة مواهب عالمية مع تقليل تكاليف التوظيف - يمكنك الوصول إلى أفضل المحترفين بأسعار تنافسية.",
            noBorder: true,
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section4.svg",
            title: "دعم بشري مخصص",
            description:
                "احصل على إرشادات الخبراء في كل خطوة. يضمن متخصصو التوظيف لدينا توظيف مطور Angular المثالي لفريقك.",
        },
    ],
};

export const techCombinationsAr = {
    mainHeading: "أفضل تركيبات تقنية Angular لتطوير عالي الأداء",
    sectionDescription: "استغل قوة Angular مع حزمة التقنيات المناسبة لبناء تطبيقات ويب ديناميكية وقابلة للتطوير وفعالة. وظّف مطوري Angular خبراء لضمان تطوير استثنائي وتجارب مستخدم سلسة.",
    combinations: [
        {
            title: "Angular + Node.js (JS/TS)",
            description:
                "يُعد Angular في الواجهة الأمامية و Node.js (JavaScript/TypeScript) في الواجهة الخلفية خيارات قوية لتطبيقات JavaScript كاملة المكدس.",
            icons: ["angular.svg", "nodejs.svg"],
        },
        {
            title: "Angular + Django (Python)",
            description:
                "يمكن لـ Angular في الواجهة الأمامية وخدمات Django لدينا في الواجهة الخلفية بناء تطبيقات ويب حديثة مع تعاون في الوقت الفعلي ونماذج أولية سريعة.",
            icons: ["angular.svg", "python.svg"],
        },
        {
            title: "Angular + Ruby on Rails (RoR)",
            description:
                "التطبيقات التي تعتمد على واجهة برمجة التطبيقات (API) أو تحتاج إلى واجهات غنية مثالية للبناء على هذا المزيج - Angular (TypeScript) في الواجهة الأمامية و RoR في الواجهة الخلفية.",
            icons: ["angular.svg", "ruby_on_rails.svg"],
        },
        {
            title: "Angular + PHP",
            description:
                "يستخدم Angular (الواجهة الأمامية) و PHP (لغة البرمجة النصية من جانب الخادم) في تطوير تطبيقات الويب الديناميكية والتفاعلية.",
            icons: ["angular.svg", "php.svg"],
        },
    ],
};

export const HireAngularStepsAr = {
    mainHeading: "وظّف مطوري Angular في 4 خطوات بسيطة",
    sectionDescription: "العثور على مطور Angular المناسب سريع وسلس من خلال عمليتنا الفعالة المكونة من 4 خطوات.",
    buttonText: "دعنا نجد المطور المثالي لك",
    angularSteps: [
        {
            title: "اختر نموذج التعاقد الخاص بك",
            description:
                "اختر النموذج الذي يناسب مشروعك: دوام كامل، دوام جزئي، أو بالساعة - توظيف مرن مصمم خصيصًا لاحتياجاتك.",
            icon: "/images/hire-page-setps-icons/icon-1.svg",
        },
        {
            title: "اختر أفضل مطوري Angular",
            description:
                "راجع خبراء Angular الذين تم فحصهم مسبقًا وقم باختيار أفضل المرشحين لمشروعك.",
            icon: "/images/hire-page-setps-icons/icon-2.svg",
        },
        {
            title: "إجراء مقابلات شخصية",
            description:
                "قيّم المهارات والخبرة ونهج حل المشكلات من خلال مقابلات فردية.",
            icon: "/images/hire-page-setps-icons/icon-3.svg",
        },
        {
            title: "البدء والتعاون",
            description:
                "بمجرد الاختيار، ينضم مطور Angular الخاص بك إلى فريقك في غضون 24-48 ساعة، مستعدًا للمساهمة.",
            icon: "/images/hire-page-setps-icons/icon-4.svg",
        },
    ],
};

export const hireAngularCoverTheStackAr = {
    mainHeading: "عزز تطوير Angular الخاص بك باستخدام حزمة تقنيات متطورة",
    sectionDescription: "في بيتسكلان، نسرّع تطوير Angular الخاص بك باستخدام حزمة تقنيات مختارة بعناية تضمن أداءً عاليًا وقابلية للتوسع. يستفيد خبراء Angular لدينا من أحدث التقنيات لبناء تطبيقات ويب ديناميكية وسريعة الاستجابة ومخصصة لتلبية احتياجات عملك.",
    defaultOpenTab: "اللغات",
    tabs: [
        "اللغات",
        "المكتبات ومكتبات واجهة المستخدم",
        "الأطر",
        "الاختبار",
        "المنصات",
    ],
    tabItems: [
        { tab: "اللغات", icon: "/images/icon7.png", name: "HTML5" },
        { tab: "اللغات", icon: "/images/icon6.png", name: "CSS3" },
        { tab: "اللغات", icon: "/images/icontwo.png", name: "JavaScript" },
        { tab: "اللغات", icon: "/images/tech-stack-icons/typescript.svg", name: "TypeScript" },
        { tab: "اللغات", icon: "/images/tech-stack-icons/graphql.svg", name: "GraphQL" },

        { tab: "المكتبات ومكتبات واجهة المستخدم", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "المكتبات ومكتبات واجهة المستخدم", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
        { tab: "المكتبات ومكتبات واجهة المستخدم", icon: "/images/iconthree.png", name: "React" },
        { tab: "المكتبات ومكتبات واجهة المستخدم", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
        { tab: "المكتبات ومكتبات واجهة المستخدم", icon: "/images/iconone.png", name: "Angular CLI" },

        { tab: "الأطر", icon: "/images/tech-stack-icons/Ionic.svg", name: "Ionic" },
        { tab: "الأطر", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
        { tab: "الأطر", icon: "/images/database2.png", name: "Nest Js" },
        { tab: "الأطر", icon: "/images/mobile4.png", name: "Flutter" },
        { tab: "الأطر", icon: "/images/icon4.png", name: "Vue.js" },
        { tab: "الأطر", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
        { tab: "الأطر", icon: "/images/iconone.png", name: "AngularJS" },
        { tab: "الأطر", icon: "/images/iconone.png", name: "Angular2+" },

        { tab: "الاختبار", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/seaborn.svg", name: "Jmeter" },
        { tab: "الاختبار", icon: "/images/qa6.svg", name: "Selenium" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/browserstack.svg", name: "BrowserStack" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/soap-icon.svg", name: "SoapUI" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/jasmine.svg", name: "Jasmine" },
        { tab: "الاختبار", icon: "/images/tech-stack-icons/karma.svg", name: "Karma" },

        { tab: "المنصات", icon: "/images/db1.png", name: "Firebase" },
        { tab: "المنصات", icon: "/images/devops3.png", name: "Docker" },
        { tab: "المنصات", icon: "/images/cloud2.png", name: "Azure AWS" },
        { tab: "المنصات", icon: "/images/cloud3.png", name: "AWS" },
    ],
};

export const HireAngularFactsDataAr = {
    mainHeading: "حقائق سريعة عن",
    greenHeading: "فريق Angular لدينا",
    buttonText: "حجز موعد",
    factData: [
        {
            text: "يتخصص فريقنا المكون من أكثر من 10 مطورين Angular في بناء تطبيقات ويب عالية الأداء.",
        },
        {
            text: "بمتوسط ​​خبرة يزيد عن 5 سنوات، يضمن مطورونا تطويرًا على مستوى الخبراء وتنفيذًا سلسًا.",
        },
        {
            text: "نحن نستفيد من الأدوات والمكتبات الحديثة لإنشاء تطبيقات Angular سريعة وقابلة للتطوير وموثوقة.",
        },
        {
            text: "تتضمن خبرتنا تطوير واجهات مستخدم ديناميكية وتفاعلية ومتجاوبة لتجارب مستخدم محسّنة.",
        },
        {
            text: "نحن نبني تطبيقات ويب وجوال قابلة للتطوير عبر الصناعات، بما في ذلك التجارة الإلكترونية وحلول الشركات.",
        },
        {
            text: "يتفوق فريقنا في تطوير واجهات برمجة التطبيقات (API) وعمليات التكامل مع الجهات الخارجية، مما يضمن اتصالاً سلسًا بين الأنظمة.",
        },
    ],
};

export const hireAppContentAr = {
    mainHeading: "غير متأكد من فكرة تطبيقك؟ احصل على نموذج أولي في أسابيع قليلة فقط!",
    sectionDescription: "لديك فكرة تطبيق ولكنك غير متأكد من كيفية المضي قدمًا؟ يمكن لمطوري Ruby on Rails الخبراء لدينا مساعدتك في إحياء رؤيتك بنموذج أولي يعمل بكامل طاقته في غضون 6-8 أسابيع فقط. تحقق من صحة مفهومك، واختبر تفاعل المستخدمين، وقم ببناء أساس متين للنجاح على المدى الطويل - دون التخمين."
}

export const HireAngularFaqDataAr = {
    mainHeading: "الأسئلة المتداولة",
    sectionDescription: "اكتشف إجابات لأسئلة شائعة حول Angular.",
    questionAnswer: [
        {
            id: "collapseOne",
            question: "ما هو تطوير الويب باستخدام Angular؟",
            answer:
                "يشير تطوير الويب باستخدام Angular إلى إنشاء تطبيقات الويب باستخدام إطار عمل Angular، والذي يساعد المطورين على بناء تطبيقات ديناميكية وتفاعلية وقابلة للتطوير.",
        },
        {
            id: "collapseTwo",
            question: "لماذا يجب علي توظيف مطوري Angular من بيتسكلان؟",
            answer:
                "بتوظيف مطوري Angular من بيتسكلان، تحصل على وصول إلى خبراء يمكنهم إنشاء تطبيقات ويب عالية الأداء مصممة خصيصًا لاحتياجاتك، مما يضمن تجارب مستخدم سلسة ووظائف ممتازة.",
        },
        {
            id: "collapseThree",
            question: "هل يمكنكم ترحيل تطبيق الويب الحالي الخاص بي إلى Angular؟",
            answer:
                "نعم! يمكن لخبراء Angular لدينا مساعدتك في ترحيل تطبيقات الويب الحالية الخاصة بك إلى Angular، مما يضمن انتقالًا سلسًا وأداءً محسنًا.",
        },
        {
            id: "fourth",
            question: "ما أنواع التطبيقات التي يمكن بناؤها باستخدام Angular؟",
            answer:
                "باستخدام Angular، يمكننا بناء جميع أنواع التطبيقات، بما في ذلك منصات التجارة الإلكترونية، وحلول المؤسسات، وأنظمة إدارة المحتوى (CMS)، والمزيد. يعتبر Angular رائعًا لتطبيقات الويب الديناميكية والمتجاوبة.",
        },
        {
            id: "fifth",
            question: "كيف يحسن Angular أداء تطبيقي؟",
            answer:
                "يساعد Angular في بناء تطبيقات قابلة للتطوير وسريعة التحميل. يستخدم ممارسات ترميز وأدوات فعالة مثل ربط البيانات في اتجاهين وحقن التبعية لتحسين أداء التطبيق وسهولة صيانته.",
        },
        {
            id: "sixth",
            question: "كم يستغرق تطوير تطبيق ويب باستخدام Angular؟",
            answer:
                "يعتمد الجدول الزمني للتطوير على تعقيد المشروع. يمكن تطوير التطبيقات البسيطة في بضعة أسابيع، بينما قد تستغرق التطبيقات الأكبر والأكثر تعقيدًا بضعة أشهر. نحن نعمل معك لإنشاء جداول زمنية واقعية.",
        },
    ],
};

export const hireAngularEnagementModelAr = {
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    buttonText: "ابدأ الآن",
    hiringDetails: [
        {
            text: "التعاقد بالساعة",
            hours: "48",
            timeUnit: "ساعة",
            icon: "time.svg",
            bgColor: "#FDFDFF",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "ابدأ العمل في غضون "
        },
        {
            text: "التعاقد بدوام كامل",
            hours: "72",
            timeUnit: "ساعة",
            icon: "full-time.svg",
            bgColor: "#FFFEFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "ابدأ في غضون "
        },
        {
            text: "التعاقد بدوام جزئي",
            hours: "48",
            timeUnit: "ساعة",
            icon: "part-time.svg",
            bgColor: "#FDFFFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "انطلق في غضون "
        },
    ],
    headingContent: [
        {
            "text": "نماذج التعاقد"
        },
        {
            "text": "المرنة لدينا"
        },
    ],
};

export var mainBannerImgAngularArabic = {
  backgroundImage: `url(/images/hire-page-images/hire-angular.avif)`,
  factBackgroundImage: `url(/images/hire-page-images/hire-angular-arabic.avif)`,
};